export const atlasAdCatalog = {
  'atlas_ad_catalog.meta.title': 'Na prodej',
  'atlas_ad_catalog.meta.description': 'Mapa inzerátů nemovitostí celé ČR.',

  'atlas_ad_catalog.dispositions.1+kk': '1+kk',
  'atlas_ad_catalog.dispositions.1+1': '1+1',
  'atlas_ad_catalog.dispositions.2+kk': '2+kk',
  'atlas_ad_catalog.dispositions.2+1': '2+1',
  'atlas_ad_catalog.dispositions.3+kk': '3+kk',
  'atlas_ad_catalog.dispositions.3+1': '3+1',
  'atlas_ad_catalog.dispositions.4+kk': '4+kk',
  'atlas_ad_catalog.dispositions.4+1': '4+1',
  'atlas_ad_catalog.dispositions.5+kk': '5+kk',
  'atlas_ad_catalog.dispositions.5+1': '5+1',
  'atlas_ad_catalog.dispositions.larger': 'Větší',
  'atlas_ad_catalog.dispositions.atypic': 'Atypický',

  'atlas_ad_catalog.remove_cutout': 'Zrušit hranice',

  'atlas_ad_catalog.sidebar.ad_estate_list_view.sorting.newest': 'nejnovější',
  'atlas_ad_catalog.sidebar.ad_estate_list_view.sorting.lowest_price':
    'nejlevnější',
  'atlas_ad_catalog.sidebar.ad_estate_list_view.sorting.highest_price':
    'nejdražší',
  'atlas_ad_catalog.sidebar.ad_estate_list_view.sorting.price_decreased':
    'zlevněné',

  'atlas_ad_catalog.sidebar.pages_count': 'Nemovitostí na stránce',

  'atlas_ad_catalog.sidebar.close': 'Zavřít',

  'atlas_ad_catalog.estate_item.info.estateType.flat': `{disposition, select, 
    undefined {Prodej bytu}
    other {Prodej bytu {disposition}}
   }`,
  'atlas_ad_catalog.estate_item.info.estateType.family': `Prodej domu`,
  'atlas_ad_catalog.estate_item.info.estateType.farmstead': `Prodej zemědělské usedlosti`,
  'atlas_ad_catalog.estate_item.info.estateType.project': `Prodej projektu`,
  'atlas_ad_catalog.estate_item.info.estateType.multigenerational_house': `Prodej vícegeneračního domu`,
  'atlas_ad_catalog.estate_item.info.estateType.villa': `Prodej vily`,
  'atlas_ad_catalog.estate_item.info.estateType.hut': 'Prodej chaty',
  'atlas_ad_catalog.estate_item.info.estateType.cottage': 'Prodej chalupy',
  'atlas_ad_catalog.estate_item.info.estateType.building_plot':
    'Prodej stavebního pozemku',
  'atlas_ad_catalog.estate_item.info.estateType.undefined':
    'Prodej nemovitosti',

  'atlas_ad_catalog.estate_item.info.area': '{area} m²',
  'atlas_ad_catalog.estate_item.info.secondary_area': 'pozemek {area} m²',
  'atlas_ad_catalog.estate_item.info.price_per_square_m':
    '{price}/m<sup>2</sup>',

  'atlas_ad_catalog.sidebar.ad_estate_list_view.small_title': `{type, select,
    flat {Byty}
    house {Domy}
    recreational_building {Chaty a chalupy}
    building_parcel {Stavební pozemky}
    other {Nemovitosti}
   } na prodej`,

  'atlas_ad_catalog.sidebar.ad_estate_list_view.title': `{type, select,
    flat {Byty}
    house {Domy}
    recreational_building {Chaty a chalupy}
    building_parcel {Stavební pozemky}
    other {Nemovitosti}
   } na prodej {radius, select,
    true {v okolí {localityType, select,
      street {ulice}
      cadastralArea {katastrálního území}
      momc {městské části}
      municipality {obce}
      district {okresu}
      region {kraje}
      other {}
    }}
    false {{localityType, select, 
      street {v ulici}
      cadastralArea {v katastrálním území}
      momc {v městské části}
      municipality {v obci}
      district {v okresu}
      region {v kraji}
      other {}}}
    other {}
  } {name}`,

  'atlas_ad_catalog.sidebar.ad_estate_list_view.subtitle': `<b>{count}</b> {count, select,
    1 {nemovitost}
    2 {nemovitosti}
    3 {nemovitosti}
    4 {nemovitosti}
    other {nemovitostí}
  }`,

  'atlas_ad_catalog.sidebar.point_detail.title': `Inzeráty v lokalitě:`,
  'atlas_ad_catalog.sidebar.point_detail.subtitle': `{count} {count, select,
    1 {vystavený inzerát}
    2 {vystavené inzeráty}
    3 {vystavené inzeráty}
    4 {vystavené inzeráty}
    other {vystavených inzerátů}
  }`,

  'atlas_ad_catalog.sidebar.similar_ad_estates.title': `Podobné inzeráty`,
  'atlas_ad_catalog.sidebar.similar_ad_estates.load_more': `Načíst další`,

  'atlas_ad_catalog.filters.type': 'Typ nemovitostí',
  'atlas_ad_catalog.filters.disabled_tooltip': 'Připravujeme',

  'atlas_ad_catalog.filters.bottom_bar.accept': 'Potvrdit',
  'atlas_ad_catalog.filters.bottom_bar.cancel': 'Zrušit filtr',

  'atlas_ad_catalog.filters.estate_type.flat': 'Byty',
  'atlas_ad_catalog.filters.estate_type.house': 'Domy',
  'atlas_ad_catalog.filters.estate_type.recreational_building':
    'Chaty a chalupy',
  'atlas_ad_catalog.filters.estate_type.building_parcel': 'Stav. pozemky',

  'atlas_ad_catalog.filters.price.title': 'Cena v Kč',
  'atlas_ad_catalog.filters.price.default_placeholder': 'Cena',
  'atlas_ad_catalog.filters.price.min_max_placeholder': '{min} - {max} Kč',
  'atlas_ad_catalog.filters.price.min_placeholder': '{min} - ∞ Kč',
  'atlas_ad_catalog.filters.price.max_placeholder': '0 - {max} Kč',
  'atlas_ad_catalog.filters.price.placeholders': 'libovolná',

  'atlas_ad_catalog.filters.disposition.placeholder': 'Dispozice',

  'atlas_ad_catalog.filters.land_area.title': 'Výměra v m²',
  'atlas_ad_catalog.filters.land_area.default_placeholder': 'Výměra',
  'atlas_ad_catalog.filters.land_area.min_max_placeholder': '{min} - {max} m²',
  'atlas_ad_catalog.filters.land_area.min_placeholder': '{min} - ∞ m²',
  'atlas_ad_catalog.filters.land_area.max_placeholder': '0 - {max} m²',
  'atlas_ad_catalog.filters.land_area.placeholders': 'libovolná',

  'atlas_ad_catalog.filters.mobile.filters': 'Filtrace:',
  'atlas_ad_catalog.filters.mobile.range.from': 'Od',
  'atlas_ad_catalog.filters.mobile.range.to': 'Do',

  'atlas_ad_catalog.filters.radius.default_placeholder': 'Přidat okolí',
  'atlas_ad_catalog.filters.radius.mobile.default_placeholder': '+ Okolí',
  'atlas_ad_catalog.filters.radius.placeholder': '{radius} km',
  'atlas_ad_catalog.filters.radius.null': 'Nezadáno',
  'atlas_ad_catalog.filters.radius.a': '0,5 km',
  'atlas_ad_catalog.filters.radius.b': '1 km',
  'atlas_ad_catalog.filters.radius.c': '5 km',
  'atlas_ad_catalog.filters.radius.d': '10 km',
  'atlas_ad_catalog.filters.radius.e': '25 km',
  'atlas_ad_catalog.filters.radius.own': 'Vlastní',
  'atlas_ad_catalog.filters.radius.suffix': 'km',
};
